import { memo } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export interface LoadingStateProps {
  message?: string;
  size?: number;
  fullPage?: boolean;
}

/**
 * Reusable loading state component with optional message
 */
export const LoadingState = memo<LoadingStateProps>(({
  message,
  size = 40,
  fullPage = false,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      py: fullPage ? 0 : 4,
      minHeight: fullPage ? '100vh' : undefined,
      gap: 2,
    }}
  >
    <CircularProgress size={size} />
    {message && (
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    )}
  </Box>
));

LoadingState.displayName = 'LoadingState';

export default LoadingState;
